/**
 * bgImageManifest.ts
 *
 * Lists every available hero background image.
 * Add a new entry here whenever you drop a new image into assets/bg-images/.
 *
 * Webpack bundles the images as asset resources and resolves the `require()`
 * calls to their final public URLs (e.g. /assets/mountains.jpg).
 *
 * ── How to add a new image ────────────────────────────────────────────────
 * 1. Drop the file into  assets/bg-images/my-new-image.jpg
 * 2. Add one entry to the array below:
 *    { id: 'my-new-image', filename: 'my-new-image.jpg',
 *      url: require('../../assets/bg-images/my-new-image.jpg') }
 * 3. Restart the dev server (npm start) — no other changes needed.
 * ─────────────────────────────────────────────────────────────────────────
 */

import type { BgImageEntry } from "../taskpane/hooks/useBgImages.hook";

export const BG_IMAGES: BgImageEntry[] = [
  {
    id: "bg-image-1",
    filename: "bg-image-1.png",
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    url: require("../../assets/bg-images/bg-image-1.png"),
    label: "Bg Image 1",
  },
  {
    id: "bg-image-2",
    filename: "bg-image-2.png",
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    url: require("../../assets/bg-images/bg-image-2.png"),
    label: "Bg Image 2",
  },
  {
    id: "bg-image-3",
    filename: "bg-image-3.png",
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    url: require("../../assets/bg-images/bg-image-3.png"),
    label: "Bg Image 3",
  },
  {
    id: "bg-image-4",
    filename: "bg-image-4.png",
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    url: require("../../assets/bg-images/bg-image-4.png"),
    label: "Bg Image 4",
  },
  {
    id: "bg-image-5",
    filename: "bg-image-5.png",
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    url: require("../../assets/bg-images/bg-image-5.png"),
    // thumbnail (optional) — points to a small preview in temp-thumbnails
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    label: "Bg Image 5",
  },
];